import { GET_ITEMS_TRANSACTIONS_LIST } from '../../modules/constants';

export function getItemsTransactionsList(value) {
  console.log('🚀 ~ itemsTransactionsReportActions.js:4 ~ value:', value);
  return {
    type: GET_ITEMS_TRANSACTIONS_LIST,
    payload: value,
  };
}
